<template>
  <div class="max-w-3xl mx-auto py-4">
    <div class="bg-white p-4 rounded-md text-xl flex items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mr-2 text-green-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p v-html="confirmText"></p>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  data() {
    return {
      order: {},
      store: {},
      confirmText: ""
    };
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  created() {
    this.getCodOrder();
    this.confirmOrder();
    // eslint-disable-next-line
    if ($crisp) {
      // eslint-disable-next-line
      $crisp.push(["do", "chat:hide"]);
    }
  },
  methods: {
    getCodOrder() {
      const shortCode = this.$route.params.shortCode;
      this.$store
        .dispatch("getCodOrder", {
          shortCode
        })
        .then(response => {
          if (response.config.codOrder) {
            this.confirmText = response.config.codOrder.codConfirmText;
          } else {
            this.confirmText = "Hi! Your order is confirmed";
          }
        });
    },
    confirmOrder() {
      const shortCode = this.$route.params.shortCode;
      this.$store.dispatch("updateCodOrder", {
        requestParams: { isConfirmed: true },
        shortCode
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
